import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  STOCK_TAKING_CAR_MANAGEMENT_GET_REFERENCE_PRICES_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_GET_REFERENCE_PRICES_FAILURE
} from '../constants'

export function* getReferencePricesSaga({data:{versionId, year}}) {
  try {
    if(versionId && year){
        const result =  yield call(BFFAgent.Datamasters.getReferencePrices, versionId)
        const resultData = result?.data?.data
        const filteredData = resultData?.filter((data) => Number(data.year) === Number(year))[0]

        yield put({
            type: STOCK_TAKING_CAR_MANAGEMENT_GET_REFERENCE_PRICES_SUCCESS,
            data: {
                rp_update_date: filteredData.updatedAt,
                reference_price: filteredData.price
            }
        })
    } else {
        yield put({
        type: STOCK_TAKING_CAR_MANAGEMENT_GET_REFERENCE_PRICES_FAILURE,
        data: { error : 'No se envió el objeto de datos' }
        })
    }
  } catch (error) {
    yield put({
      type: STOCK_TAKING_CAR_MANAGEMENT_GET_REFERENCE_PRICES_FAILURE,
      data: { error }
    })
  }
}
